module.exports = "images/decommissionementSplashscreen.7f938b37.gif";